
import {
  API_FEED_REQUEST,
  API_FEED_RECEIVE_SUCCESS,
  API_FEED_RECEIVE_FAILURE
} from '../const/action_types.js';

import {
  hashFilters
} from 'zoomforth_tools/standard_feed_filtering.js';


const getIdentStr = ({ id, filters })=> {
  const filterHash = hashFilters(filters);
  return `${id}:${filterHash}`;
};


export default (state = {}, action)=> {

  switch (action.type) {

  case API_FEED_REQUEST:
  
    return {
      ...state,
      isLoading: true
    };

  case API_FEED_RECEIVE_SUCCESS:
    return {
      ...state,
      isLoading: false,
      apiFeedByIdent: {
        ...state.apiFeedByIdent,
        [getIdentStr(action)]: action.data
      },
      error: false
    };

  case API_FEED_RECEIVE_FAILURE:
    return {
      ...state,
      isLoading: false,
      error: true
    };

  default:
    return state;

  }

};

export const getIsLoading = (state)=>
  state.isLoading;

export const getFilteredApiFeed = (state, apiFeedId, { filters })=>
  (state.apiFeedByIdent || {})[getIdentStr({ id:apiFeedId, filters })];

export const getErrorInFilteredApiFeed = (state)=>
  state.error || false;
